import { render, staticRenderFns } from "./CancelTruckOrders.vue?vue&type=template&id=10cc926c&scoped=true&"
import script from "./CancelTruckOrders.vue?vue&type=script&lang=js&"
export * from "./CancelTruckOrders.vue?vue&type=script&lang=js&"
import style0 from "./CancelTruckOrders.vue?vue&type=style&index=0&id=10cc926c&scoped=true&lang=css&"
import style1 from "./CancelTruckOrders.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc926c",
  null
  
)

export default component.exports